export * from './BarcodeDetectorPolyfill'
export * from './DetectedBarcode'
export * from './ZBarConfig'

// To be resolved by @rollup/plugin-replace
export const ZBAR_WASM_PKG_NAME = '__ZBAR_WASM_PKG_NAME__'
export const ZBAR_WASM_VERSION = '__ZBAR_WASM_VERSION__'
export const ZBAR_WASM_REPOSITORY = '__ZBAR_WASM_REPOSITORY__'
